import { forwardRef, useRef } from "react";
import { formatDateTime } from "../../../commons/utils";
import { ConsultaPadrao } from "../../../components/ConsultaPadrao";
import { model_programacao_coleta } from "../../../models";

// const ToggleButtonSt = styled(ToggleButton)({
//     paddingRight: '16px',
//     paddingLeft: '16px',
//     '&:hover': {
//         backgroundColor: '#00141430',
//     },
//     "&.Mui-selected, &.Mui-selected:hover": {
//         color: "white",
//         backgroundColor: '#001414'
//     }
// })

// const columns = [
//     { field: 'grudescricao', header: 'Empresa', style: { width: window.innerWidth, whiteSpace: 'pre-wrap' } },
//     { field: 'countforms', header: 'Formulários', dataType: 'numeric' },
//     { field: 'count7', header: 'Semana', dataType: 'numeric' },
//     { field: 'count30', header: 'Mês', dataType: 'numeric' },
//     { field: 'count90', header: '90 dias', dataType: 'numeric' },
// ];

export const DashProgramacoes = forwardRef((props: any, ref) => {
    // const auth = useAuth();

    const refdatatable = useRef<any>(null);
    // const tipomovref = useRef<any>(null);
    // const iemissaoref = useRef<any>(null);
    // const femissaoref = useRef<any>(null);

    // const [showing, setShowing] = useState(false);

    const columns = [
        // { field: 'movimentodescricao', header: 'Identificador', style: { whiteSpace: 'pre-wrap' } },
        { field: 'progdescricao', header: 'Descrição', style: { whiteSpace: 'pre-wrap' } },
        { field: 'progcontadorcoleta', header: 'Último nº', style: { whiteSpace: 'pre-wrap' } },
        { field: 'progdatainicio', header: 'Data Início', body: (e: any) => formatDateTime(e.progdatainicio), dataType: 'date' },
        { field: 'grudescricao', header: 'Grupo', style: { whiteSpace: 'pre-wrap' } },
        { field: 'dataultimacoleta', header: 'Data Última Coleta', body: (e: any) => formatDateTime(e.dataultimacoleta), dataType: 'date' },
        { field: 'usuultimacoleta', header: 'Usuário Última Coleta', style: { whiteSpace: 'pre-wrap' } },
        { field: 'count7', header: 'Semana', style: { whiteSpace: 'pre-wrap' } },
        { field: 'count30', header: 'Mês', style: { whiteSpace: 'pre-wrap' } },
        { field: 'count90', header: '90 dias', style: { whiteSpace: 'pre-wrap' } },
        // { field: 'volume', header: 'Volume (KG)', dataType: 'numeric', body: (e: any) => formatDecimal(e.volume), style: { maxWidth: '100px' } },
        // { field: 'usunome', header: 'Usuário', style: { whiteSpace: 'pre-wrap' } },
        // { field: 'tipmovstdescricao', header: 'Situação' },
        // { field: 'functions', style: { width: '1rem' } }
    ];

    // function filterData(data: any, iEmissao: any, fEmissao: any, tipMov: any) {
    //     let _data: any = [];

    //     _data = data;

    //     if (iEmissao)
    //         _data = _data.filter((item: any) => formatDataCompare(item.movemissao) >= iEmissao);

    //     if (fEmissao)
    //         _data = _data.filter((item: any) => formatDataCompare(item.movemissao) <= fEmissao);

    //     if (tipMov && (tipMov.length > 0)) {
    //         const _tipMov = new Set(tipMov.map((item: any) => item.value));
    //         _data = _data.filter((item: any) => _tipMov.has(item.tipmovcontador));
    //     }

    //     setLocalStorage('i_emissao_tipmov_mov', iEmissao ?? null);
    //     setLocalStorage('f_emissao_tipmov_mov', fEmissao ?? null);

    //     refdatatable.current.setCustomData(_data);
    // }

    // function afterRefresDataTable(data: any) {
    //     var iEmissao;
    //     var fEmissao;

    //     if (!showing) {
    //         // iEmissao = getLocalStorage('i_emissao_tipmov_mov');
    //         // fEmissao = getLocalStorage('f_emissao_tipmov_mov');

    //         filterData(data, iEmissao, fEmissao, []);

    //         setShowing(true);
    //     } else
    //         filterData(data, iemissaoref.current.getValue(), femissaoref.current.getValue(), tipomovref.current.getValue())
    // }

    // async function changeEmissaoInicial(value: any, data: any) {
    //     filterData(data, value, femissaoref.current.getValue(), tipomovref.current.getValue())
    // }

    // async function changeEmissaoFinal(value: any, data: any) {
    //     filterData(data, iemissaoref.current.getValue(), value, tipomovref.current.getValue())
    // }

    // async function changeTipoMovimento(selecteds: any, data: any) {
    //     filterData(data, iemissaoref.current.getValue(), femissaoref.current.getValue(), selecteds)
    // }

    // const filters = [
    //     {
    //         ref: iemissaoref, md: 2, id: 'i_emissao_tipmov_mov', label: 'Emissão Inicial', type: 'date',
    //         onChange: changeEmissaoInicial, defaultValue: getLocalStorage('i_emissao_tipmov_mov')
    //     },
    //     {
    //         ref: femissaoref, md: 2, id: 'f_emissao_tipmov_mov', label: 'Emissão Final', type: 'date',
    //         onChange: changeEmissaoFinal, defaultValue: getLocalStorage('f_emissao_tipmov_mov')
    //     },
    //     {
    //         ref: tipomovref, md: 8, id: 'tipmov', label: 'Tipo Movimento', type: 'select',
    //         onChange: changeTipoMovimento, model: model_tipo_movimento, isMulti: true
    //     }
    // ]

    return (
        <>
            <ConsultaPadrao
                ref={refdatatable}
                model={model_programacao_coleta}
                columns={columns}
            // inputfilters={filters}
            // onAfterRefresh={afterRefresDataTable}
            />
        </>
    )
})